import { render, staticRenderFns } from "./PortalManagement.vue?vue&type=template&id=5a50300b&"
import script from "./PortalManagement.ts?vue&type=script&lang=ts&"
export * from "./PortalManagement.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports